import { z } from 'zod'
import { emailSchema } from '~/utils/user-validation'

export const subscribeToNewsletterSchema = z.object({
	email: emailSchema,
	country: z.string().optional(),
})
